import { useEffect, useMemo } from 'react';
import { useGlobalStateContext } from '../context/GlobalStateContext/GlobalStateContext';
/**
 * Scrolls to the component with the corresponding hash when loaded
 * @param {hash} string - The id to check for and scroll to
 * @param {loaded} array - Truthy values used to determine whether or not scroll is ready
 */
// eslint-disable-next-line
const useScrollTo = (loaded = [], offset) => {
    const { globalState: { setLoadedScrollSections }, } = useGlobalStateContext();
    // loaded is an array of truthy values
    const isLoaded = useMemo(() => loaded.every((item) => item), [loaded]);
    useEffect(() => {
        if (isLoaded && window.location.hash) {
            const element = document.querySelector(window.location.hash);
            if (element) {
                setTimeout(() => {
                    window.scrollTo({
                        behavior: 'smooth',
                        top: element.getBoundingClientRect().top -
                            document.body.getBoundingClientRect().top -
                            (offset || 0),
                    });
                }, 500);
                setLoadedScrollSections({});
            }
        }
    }, [isLoaded]);
};
// 500 ms timeout is to allow any loading animations that change an element's height to finish before scrolling
export default useScrollTo;
